import React from 'react';
import { Card } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Box } from '@mui/material';

const DocumentTile = ({ data, onClick, className = "" }) => {
    const handleClick = () => {
        if (onClick) {
            onClick(data);
        }
    };

    return (
        <Box
            className={`document-tile ${className}`}
            sx={{
                width: { xs: 'calc(50vw - 16px)', sm: '280px', md: '300px' },
                minHeight: { xs: '160px', sm: '180px', md: '200px' },
                cursor: 'pointer',
                margin: 1
            }}
            onClick={handleClick}
        >
            <Card style={{ width: '100%', height: '100%' }}>
                <Card.Body>
                    <div className="d-flex align-items-center mb-2">
                        <Icon.FileText size={24} className="me-2" />
                        <h6 className="mb-0" style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px' }}>
                            {data.title || 'ドキュメント'}
                        </h6>
                    </div>
                    <p className="text-muted small" style={{ fontSize: window.innerWidth < 768 ? '12px' : '14px' }}>
                        {data.description || data.content?.substring(0, 100) + '...' || '内容が表示されます'}
                    </p>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                            作成者: {data.user_name || 'Unknown'}
                        </small>
                        <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                            {data.created_at ? new Date(data.created_at).toLocaleDateString() : ''}
                        </small>
                    </div>
                </Card.Body>
            </Card>
        </Box>
    );
};

export default DocumentTile;
